import { useMutation, useQuery } from "@tanstack/react-query";
import {
  fetchAllArticles,
  fetchArticlesBySlug,
  fetchFeaturedArticles,
  updateArticle,
  updateFeaturedArticles,
} from "../../api/blogs/articles.api";
import { showToast } from "../../helper/ShowToast";

export const useArticles = (params) => {
  return useQuery({
    queryKey: ['articles', params],
    queryFn: () => fetchAllArticles(params),
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour (formerly cacheTime)
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to fetch articles"
      ),
  });
}

export const useArticleBySlug = (slug) => {
  return useQuery({
    queryKey: ['articles', slug],
    queryFn: () => fetchArticlesBySlug(slug),
    enabled: !!slug,
    staleTime: 1000 * 60 * 30, // 30 minutes
    gcTime: 1000 * 60 * 60, // 1 hour (formerly cacheTime)
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to fetch article"
      ),
  });
}

export const useFeaturedArticles = () => {
  return useQuery({
    queryKey: ["featured-articles"],
    queryFn: fetchFeaturedArticles,
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to fetch featured articles"
      ),
  });
}

export const useUpdateFeaturedArticles = () => {
  return useMutation({
    mutationFn: updateFeaturedArticles,
    onError: (err) =>
      showToast(
        "error",
        err?.response?.data?.message || "Failed to update featured articles"
      ),
  });
}

export const useUpdateArticle = () => {
  return useMutation({
    mutationFn: ({ id, data }) => updateArticle(id, data),
  });
}
